import React from 'react';
import { Link } from 'react-router-dom';

const UnauthorizedPage: React.FC = () => {
  // Unauthorized page message can be configured through environment variable
  const unauthorizedMessage = process.env.REACT_APP_UNAUTHORIZED_MESSAGE || 
    'You do not have the required role to access this page.';

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Access Denied</h1>
      <p>{unauthorizedMessage}</p>
      <p>
        <Link 
          to="/" 
          style={{
            color: '#0078d4',
            textDecoration: 'none',
            fontWeight: 'bold'
          }}
        >
          Return to Home
        </Link>
      </p>
    </div>
  );
};

export default UnauthorizedPage;